<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1">The Losing Role</h1>
<p class="ORIM-Book-Subtitle--Front-Matter-">Book One of the Kaspar Brothers Series</p>
<p class="author">Steve Anderson</p>
<div class="img_container1">
<img alt="image" src="image/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?6cbebd26